import { Input } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { ShippingAddressInputFieldProps } from '../../types/shippingAddressInputFieldProps'

type ShippingAddressCityProps = ShippingAddressInputFieldProps

export const ShippingAddressCity = ({ isDisabled }: ShippingAddressCityProps) => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      itemColumnEnd={5}
      itemColumnStart={2}
      label={t('customer_modal.form.shipping_address.city.label')}
      name="shippingAddress.city"
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
